import { TipoModelo } from '@alianca/core/contracts/templates';

interface ModeloDeContrato {
    titulo: string;
    nomeNoEditor: string;
    descricao: string;
}

/** Como cada modelo do editor aparece na tela (cartão de Configurações e cabeçalho do editor). */
export const MODELOS_DE_CONTRATO: Record<TipoModelo, ModeloDeContrato> = {
    solar: {
        titulo: 'Solar',
        nomeNoEditor: 'Termo de filiação do Solar',
        descricao: 'Termo de filiação dos contratos de sistemas solares fotovoltaicos.',
    },
    eletroposto: {
        titulo: 'Eletropostos',
        nomeNoEditor: 'Termo de filiação de Eletropostos',
        descricao: 'Termo de filiação dos contratos de infraestrutura de recarga de veículos elétricos.',
    },
    parceria: {
        titulo: 'Contrato de parceria',
        nomeNoEditor: 'Contrato de parceria',
        descricao: 'Contrato que o parceiro assina ao entrar na rede.',
    },
};

export const TIPOS_DE_MODELO = TipoModelo.options;

export const ehTipoModelo = (valor: string): valor is TipoModelo => TipoModelo.safeParse(valor).success;
